import { styled } from '@mui/system';
import Button from '@components/Button';
import Tooltip from '@components/Tooltip';
import { useTranslation } from '@hooks';
import usePermissions from '@hooks/usePermissions';
import { useOpenUpgradeDrawer } from '@hooks/useOpenUpgradeDrawer';
import { ReactComponent as LockIcon } from 'assets/images/icons/lock.svg';

const Icon = styled(LockIcon)(({ variant }) => ({
    height: 14,
    transform: 'translateY(-1px)',
    marginRight: 4,
    ...(variant === 'contained' && {
        '& path': {
            fill: '#fff',
        },
    }),
    ...(variant === 'outlined' && {
        '& path': {
            fill: 'var(--primary-main)',
        },
    }),
    ...(variant === 'text' && {
        '& path': {
            fill: 'var(--primary-main)',
        },
    }),
}));

const LockedButton = ({ children, variant, className, drawerType, tooltipType }) => {
    const { hasFullSettings } = usePermissions();
    const { t } = useTranslation();
    const openUpgradeDrawer = useOpenUpgradeDrawer();

    const handleOpen = () => openUpgradeDrawer({ type: drawerType });

    return (
        <Tooltip placement="top" title={tooltipType === 1 ? t('common.upgradeToAdd') : t('common.upgradeToUnlock')}>
            <span>
                <Button className={className} variant={variant} onClick={handleOpen} disabled={!hasFullSettings()}>
                    <Icon variant={variant} />
                    {children}
                </Button>
            </span>
        </Tooltip>
    );
};

export default LockedButton;
